<!--
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-11-23 13:41:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-21 18:32:08
 * @FilePath: \common_web\src\views\archiveManager\arch.vue
-->
<template>
  <el-container class="arch">
    <div class="main">
      <el-container class="main_info">
        <el-main>
          <div class="content">
            <div class="title">
              <div class="flex">
                <span>{{$t('editChild.basicInfo')}}</span
                ><span class="statusname" :class="'statusname'+archobj.status" v-if='archobj.statusName'>{{ archobj.statusName }}<i></i></span>
              </div>
            </div>
            <div class="form">
              <el-form
                :label-position="labelPosition"
                size="mini"
                class="form"
                label-width="100px"
                ref="form"
                :model="archobj"
              >
                <el-form-item :label="code">
                  <el-input v-model="archobj.code" readonly></el-input>
                </el-form-item>
                <el-form-item :label="name">
                  <el-input v-model="archobj.name" readonly></el-input>
                </el-form-item>

                <el-form-item :label="$t('editChild.busArea')" v-if="usertype == '3'">
                  <el-input v-model="archobj.acreage" readonly></el-input>
                </el-form-item>
                 <el-form-item :label="$t('archiveManagerArch.storeNature')" v-if="usertype=='3'">
                  <el-input v-model="archobj.propertyName" readonly ></el-input>
                </el-form-item>
                 <el-form-item :label="$t('archiveManagerArch.shareholderNum')" v-if="usertype=='3'">
                  <el-input v-model="archobj.adminCount" readonly ></el-input>
                </el-form-item>
                <el-form-item :label="$t('editChild.addressDetail')" >
                  <el-input v-model="archobj.address" readonly></el-input>
                </el-form-item>
                <el-form-item :label="$t('applyChildDetail.bankCard')">
                  <el-input :value="maskedBankCard(archobj.bankCard)" readonly> </el-input>
                  <el-input
                    v-model="archobj.bank"
                    v-if="archobj.bank"
                    readonly
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('editChild.officePhoto')">
                  <el-image
                    style="width: 100px; height: 100px; margin-right: 10px"
                    v-for="(v, i) in archobj.photo1"
                    :key="i"
                    :src="v.url"
                    :preview-src-list="[v.url]"
                  >
                  </el-image>
                </el-form-item>

                <!-- <div class="bnt" v-if="userInfo.archiveApplyFlag&&!isdisabled"><el-button type="primary" @click="sub1">提 交</el-button></div> -->
              </el-form>
            </div>
          </div>
        </el-main>
        <el-main>
          <div class="content">
            <div class="title">
                <div >
                 <el-radio-group v-model="radio1" size="mini" @input="inputchange">
                  <el-radio :label="i+1" border v-for="(item,i) in userinfoList" :key="i">{{item.typeName}}</el-radio>

                </el-radio-group>
                </div>
            </div>
            <div class="form">
              <el-form
                :label-position="labelPosition"
                size="mini"
                class="form"
                label-width="100px"
                ref="form"
                :model="formLabelAlign"
              >
                <el-form-item :label="$t('editChild.photo')">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="formLabelAlign.photo"
                    :preview-src-list="[formLabelAlign.photo]"
                  >
                  </el-image>
                </el-form-item>
                <el-form-item :label="$t('editChild.name')">
                  <el-input v-model="formLabelAlign.name" readonly></el-input>
                </el-form-item>
                <el-form-item :label="$t('editChild.gender')">
                  <el-input
                    v-model="formLabelAlign.sexName"
                    readonly
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('editChild.maritalStatus')">
                  <el-input
                    v-model="formLabelAlign.maritalStatusName"
                    readonly
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('editChild.numberID')">
                  <el-input v-model="formLabelAlign.idCard" readonly></el-input>
                </el-form-item>
                <el-form-item :label="$t('editChild.birthday')">
                  <el-input
                    v-model="formLabelAlign.birthday"
                    readonly
                  ></el-input>
                </el-form-item>

                <el-form-item :label="$t('editChild.contactNumber')">
                  <el-input v-model="formLabelAlign.phone" readonly></el-input>
                </el-form-item>

              </el-form>
              <el-form
                :label-position="labelPosition"
                size="mini"
                class="form"
                label-width="100px"
                ref="urgentUser"
                :model="urgentUser"
              >
                <div class="form_title">
                  <p><span></span>{{$t('archiveManagerArch.contactEmergency')}}</p>
                </div>

                <el-form-item :label="$t('editChild.name')">
                  <el-input v-model="urgentUser.name" readonly></el-input>
                </el-form-item>

                <el-form-item :label="$t('editChild.contactNumber')">
                  <el-input v-model="urgentUser.phone" readonly></el-input>
                </el-form-item>
                <!-- <div class="bnt" v-if="userInfo.archiveApplyFlag"><el-button type="primary" @click="subuser">提 交</el-button></div> -->
              </el-form>
            </div>
          </div>
        </el-main>
      </el-container>
      <!-- <div class="bnt" v-if="!userInfo.archiveApplyFlag"><el-button type="primary" @click="sub">提 交</el-button></div> -->
    </div>
  </el-container>
</template>
<script>
import FileUpload from "@/components/fileUpload.vue";
import {
  shopArchiveUserdetail,shopuserdetail,generalArchiveUserdetail,generalArchivedetail,areaArchiveUserdetail,areaArchivedetail
} from "@/api/addDevice.js";
export default {
  data() {
    return {
      radio1:1,
      formLabelAlign: {
        photo1: [],
      },
      archobj: {
        photo1: [],
      },
      urgentUser: {
        photo1: [],
      },
      labelPosition: "right",
      relationList: [
        { name: "", relation: "", frontFlag: 1 },
        { name: "", relation: "", frontFlag: 2 },
      ],

      drawer: false,
      relationlist: [],
      userList: [],
      userid: "",

      isdisabled: true,
      requestlist: [
        { name: "3", val: shopuserdetail },
        { name: "1", val: generalArchivedetail },
        { name: "2", val: areaArchivedetail },
        { name: "4", val: areaArchivedetail },
      ],
      requestuserlist: [
        { name: "3", val: shopArchiveUserdetail },
        { name: "1", val: generalArchiveUserdetail },
        { name: "2", val: areaArchiveUserdetail },
        { name: "4", val: areaArchiveUserdetail },
      ],
      userinfoList:[],
      usertype: "",
      id: "",
      name:'',
      code:''
    };
  },
  filters: {
    fitlerBankCard(item) {
      return `${item}`.replace(/^(.{4})(?:\d+)(.{4})$/, "$1 **** **** $2");
    },
  },
  components: {
    FileUpload,
  },
  mounted() {
    console.log(this.status);
    if(this.status){
      this.usertype = this.status
      this.id = this.ids
    }
    if(this.$route.query.type){
      this.usertype = this.$route.query.type;
      this.id = this.$route.query.id;
    }

    this.setname()

    this.getgenuser();
    this.getgenArchiveUser();
  },
  props:{
    status:{
      type:String
    },
    ids:{
      type:String
    }
  },
  methods: {
    maskedBankCard(v="") {


      if (v.length <= 8) return v   // 太短就不脱敏

      const first4 = v.slice(0, 4)
      const last4 = v.slice(-4)

      // 隐藏部分长度：至少 8 位，并按 4 位分组对齐
      let hiddenLen = Math.max(8, v.length - 8)
      hiddenLen = Math.ceil(hiddenLen / 4) * 4

      const middle = '*'.repeat(hiddenLen)

      // 合并后按 4 位分组
      return (first4 + middle + last4).replace(/(.{4})/g, '$1 ').trim()
    },
    inputchange(e){

      let res = this.userinfoList[e-1]

      this.relationList = res.children ? res.children : [];
      this.formLabelAlign = this.setphoto1(res);
      this.urgentUser = this.setphoto1(res.emergencyContactUser);
    },
    setname() {
      if (this.usertype == "3") {
        this.name = this.$t('applyChildDetail.storeName');
        this.code = this.$t('applyChildDetail.storeCode');
      } else if (this.usertype == "1") {
        this.name = this.$t('checkChild.totalName');
        this.code = this.$t('checkChild.totalCode');
      } else {
        this.name = this.$t('checkChild.disName');
        this.code = this.$t('checkChild.disCode');
      }
    },
    async getgenuser(info) {
      let pro = "";
      this.requestlist.map((v) => {
        if (v.name == this.usertype) {
          pro = v.val;
        }
      });
      await pro({ id: this.id }).then((res) => {
        if (res.data.code == 200) {
          if (info) {
            this.userid = res.data.data.id;
          } else {
            this.userid = res.data.data.id;
            this.archobj = res.data.data;
            this.archobj = this.setphoto1(this.archobj);
            this.$emit('archobj',this.archobj)
          }
        }
      });
    },
    getgenArchiveUser(info) {
      let pro = "";
      this.requestuserlist.map((v) => {
        if (v.name == this.usertype) {
          pro = v.val;
        }
      });
      pro({ id: this.id }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data.length > 0) {
            res = res.data.data;
            this.userinfoList = res
            if (info) {
              return
            } else {
              this.relationList = res[0].children ? res[0].children : [];
              this.formLabelAlign = this.setphoto1(res[0]);
              this.urgentUser = this.setphoto1(res[0].emergencyContactUser);
            }
            console.log(this.urgentUser, this.formLabelAlign);
          }
        }
      });
    },
    sub() {
      this.setphoto(this.archobj);
      this.setphoto(this.formLabelAlign);
      this.setphoto(this.urgentUser);
      console.log(
        this.formLabelAlign,
        this.archobj,
        this.relationList,
        this.urgentUser
      );
      genArchiveRecord(this.archobj).then((res) => {
        if (res.data.code == 200) {
          this.getgenuser("1");
          this.getgenArchiveUser("add");
        }
      });
    },
    // sub1(){
    //   this.setphoto(this.archobj)
    //   genArchivePut(this.archobj).then(async res=>{
    //     if(res.data.code==200){
    //       await this.getsubmitgencheck()
    //       this.isdisabled = true
    //     }
    //   })
    // },

    del(frontFlag) {
      this.relationList.map((item, index) => {
        if (item.frontFlag === frontFlag) {
          this.relationList.splice(index, 1);
        }
      });
    },
    setphoto(obj) {
      let arr = [];
      obj.photo1.map((item) => {
        arr.push(item.url);
      });
      obj.photo = arr.toString();
    },
    setphoto1(obj = {}) {
      let arr = [];
      if (obj.photo) {
        obj.photo.split(",").map((item, i) => {
          arr.push({ url: item, name: i });
        });
      }

      obj.photo1 = arr;
      return obj;
    },
    addrela() {
      let pro = (this.relationList || []).map((x) => x.frontFlag);

      var result = 0;
      if (pro.length > 0) {
        result = Math.max(...pro);
      }

      this.relationList.push({
        name: "",
        relation: "",
        frontFlag: result ? result + 1 : 1,
      });
    },
  },
};
</script>
<style lang="scss">
.arch {
  padding: 20px !important;
  .bnt {
    padding: 20px 0;
    text-align: center;
  }
  .main {
    width: 100%;
    &_info {
      height: 100%;
      flex-basis: 0;
    }
  }
  .el-main {
    flex-basis: 0;
  }
  .el-main:nth-of-type(1) {
    margin-right: 20px;
  }
  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    .title {
      height: 60px;
      padding: 0 20px;
      font-size: 16px;
      line-height: 60px;
      display: flex;
      justify-content: space-between;
      background: #f4f5fa;
      span {
        cursor: pointer;
      }
    }
    .statusname {
      color: #e6a23c;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 20px;

      i {
        display: inline-block;
        margin-left: 5px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #e6a23c;
      }
    }
    .statusname2{
      color: #f56c6c;
      i {
        background: #f56c6c;
      }
    }
    .statusname3 {
      color: #50c4cb;
      i {
          background: #50c4cb;
        }
    }
    .form {
      padding: 0 20px;
      flex: 1;
      overflow: auto;
      margin-top: 20px;
      &_title {
        line-height: 40px;
        font-size: 16px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        i {
          color: #50c4cb;
          font-size: 28px;
        }
        font-weight: bold;
        span {
          display: inline-block;
          width: 8px;
          margin-right: 10px;
          height: 8px;
          border-radius: 50%;
          background: #50c4cb;
        }
      }
      .fam {
        display: flex;
        &_remove {
          width: 60px;
          display: flex;
          margin-top: 30px;
          justify-content: center;
          i {
            color: #d84422;
            cursor: pointer;
            font-size: 28px;
          }
        }
        &_rig {
          flex: 1;
        }
      }
    }
  }
  .el-form-item {
    border-bottom: 1px solid #ccc;
    padding-bottom: 12px;
    margin-bottom: 12px;
  }
  .el-textarea__inner,
  .el-input__inner {
    border: none;
    font-size: 14px;
    color: #333;
  }
  .el-input__inner:focus {
    box-shadow: none !important;
  }
  ::-webkit-scrollbar {
    width: 0;
  }
}
</style>
